import React, { useEffect, useState } from "react";
import {
  Table,
  message,
  Spin,
  Typography,
  notification,
  Select,
  Modal,
  Statistic,
  Button,
  Col,
  Row,
  Card,
  Input,
  Alert,
  Tooltip,
  Space,
  Drawer,
} from "antd";
import {
  SearchOutlined,
  ClearOutlined,
  FilePdfOutlined,
  EyeOutlined,
  CloseOutlined,
} from "@ant-design/icons";

import getHistorialVisitasPatti from "../../../services/visitas_tecnicas/getHistorialVisitasPatti";
import Renderizar from "../../Participants/renderizarReporte";
const { Option } = Select;

const { Text, Title } = Typography;

const TablaHistorialVisitas = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [itemSeleccionado, setItemSeleccionado] = useState(null);
  const [showDetalleVisita, setShowdetalleVisita] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedFormType, setSelectedFormType] = useState(null);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [recordSeleccionado, setRecordSeleccionado] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await getHistorialVisitasPatti();
      const { status, data } = response;

      if (status === 200) {
        setData(data);
        setFilteredData(data);
      } else {
        notification.error({
          message: "Error",
          description: message || "Failed to fetch  data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filterData = (texto, formType) => {
    let filtered = [...data];

    if (texto?.trim()) {
      filtered = filtered.filter((item) =>
        Object.values(item).some(
          (val) =>
            typeof val === "string" &&
            val.toLowerCase().includes(texto.toLowerCase())
        )
      );
    }

    if (formType) {
      filtered = filtered.filter((item) => item.tipo_visita === formType);
    }

    setFilteredData(filtered);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    filterData(value, selectedFormType);
  };

  const handleFormTypeChange = (value) => {
    setSelectedFormType(value);
    filterData(searchText, value);
  };

  const handleClearFilters = () => {
    setSelectedFormType(null);
    setSearchText("");
    setFilteredData(data);
  };

  const visualizarPDF = (record) => {
    setItemSeleccionado(record);
    setShowdetalleVisita(true);
    // Aquí colocas tu lógica para abrir el PDF, por ejemplo:
    // window.open(record.url_pdf, '_blank');
  };

  const cerrarModal = () => {
    setIsModalVisible(false);
    setRecordSeleccionado(null);
  };

  const visualizarCambios = (record) => {
    setRecordSeleccionado(record);
  };

  // Mostrar modal solo cuando el estado ya cambió
  useEffect(() => {
    if (recordSeleccionado) {
      setIsModalVisible(true);
    }
  }, [recordSeleccionado]);
  // Función para renderizar el contenido dinámico

  const renderCambios = () => {
    if (!recordSeleccionado?.updateData) {
      return <p>No hay cambios para mostrar.</p>;
    }

    return (
      <pre
        style={{
          backgroundColor: "#f5f5f5",
          padding: "16px",
          borderRadius: "8px",
          maxHeight: "400px",
          overflowY: "auto",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontSize: "12px",
        }}
      >
        {JSON.stringify(recordSeleccionado.updateData, null, 2)}
      </pre>
    );
  };

  const columns = [
    {
      title: "id",
      dataIndex: "id",
      key: "id",
      width: 50,
    },
    {
      title: "Código interno",
      dataIndex: "codigo_pdf",
      key: "código pdf",
      width: 150,
    },

    {
      title: "Tipo visitas",
      dataIndex: "tipo_visita",
      key: "tipo_visita",
      width: 150,
    },
    {
      title: "Responsable",
      dataIndex: "user",
      key: "user",
      width: 30,
    },

    {
      title: "Código SIR",
      dataIndex: "codigo_sir",
      key: "codigo_sir",
      width: 120,
    },

    {
      title: "Nombre Titular",
      dataIndex: "nombre_participante",
      key: "nombre_participante",
      width: 80,
    },

    {
      title: "Fecha",
      dataIndex: "fecha",
      key: "fecha",
      width: 150,
    },
    {
      title: "Acciones",
      key: "acciones",
      width: 100, // Ajusta el ancho para que entren bien los dos botones
      render: (record) => (
        <Space>
          {/* Botón Visualizar PDF */}
          <Tooltip title="Visualizar formato">
            <Button
              type="primary"
              icon={<FilePdfOutlined />}
              size="small"
              shape="circle"
              onClick={() => visualizarPDF(record)}
            />
          </Tooltip>

          {/* Botón Visualizar cambios */}
          <Tooltip title="Visualizar cambios">
            <Button
              type="default"
              icon={<EyeOutlined />}
              size="small"
              shape="circle"
              onClick={() => visualizarCambios(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      {/* Aquí va el resto del contenido que deseas mostrar cuando no se está creando una novedad */}
      {loading ? (
        <div className="text-center">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div className="container mt-4">
            <Row gutter={[16, 16]} className="mb-4">
              <Col span={24}>
                <div className="filter-container">
                  <Row gutter={[16, 16]} align="middle">
                    {/* Filtro tipo de formulario */}
                    <Col xs={24} sm={12} md={6} lg={5}>
                      <div className="filter-item">
                        <Title
                          level={5}
                          className="filter-label"
                          style={{ color: "#042956" }}
                        >
                          Tipo formulario
                        </Title>
                        <Select
                          style={{ width: "100%" }}
                          placeholder="Seleccione tipo formulario"
                          allowClear
                          value={selectedFormType}
                          onChange={handleFormTypeChange}
                        >
                          <Option value="Consentimiento">Consentimiento</Option>
                          <Option value="Diagnóstico">Diagnóstico</Option>
                          <Option value="Análisis de capacidades">
                            Análisis de capacidades
                          </Option>
                          <Option value="Autorizacion de imagen">
                            Autorizacion de imagen
                          </Option>
                          <Option value="Acta de inicio">Acta de inicio</Option>
                        </Select>
                      </div>
                    </Col>

                    {/* Barra de búsqueda */}
                    <Col xs={24} sm={12} md={6} lg={8}>
                      <div className="filter-item">
                        <Title
                          level={5}
                          className="filter-label"
                          style={{ color: "#042956" }}
                        >
                          Búsqueda
                        </Title>
                        <Input
                          placeholder="Buscar..."
                          prefix={<SearchOutlined />}
                          value={searchText}
                          onChange={handleSearch}
                        />
                      </div>
                    </Col>

                    {/* Botón Limpiar */}
                    <Col xs={12} sm={6} md={3} lg={3}>
                      <Button
                        type="primary"
                        onClick={handleClearFilters}
                        icon={<ClearOutlined />}
                        style={{ width: "100%", marginTop: "24px" }}
                      >
                        Limpiar
                      </Button>
                    </Col>

                    {/* Total */}
                    <Col xs={12} sm={6} md={3} lg={3}>
                      <Card
                        size="small"
                        style={{
                          marginTop: "24px",
                          textAlign: "center",
                          backgroundColor: "#f0f5ff", // Fondo azul claro
                        }}
                      >
                        <Statistic
                          title="Total registros"
                          value={filteredData.length}
                          valueStyle={{
                            color: "#1890ff",
                            fontWeight: "bold",
                          }}
                        />
                      </Card>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <div className="row mb-4">
              <div className="col-12">
                {filteredData.length > 0 ? (
                  <Table
                    columns={columns}
                    dataSource={filteredData}
                    rowKey="id"
                    pagination={{ pageSize: 20 }}
                    bordered
                    scroll={{ y: 500, x: "max-content" }}
                  />
                ) : (
                  <div style={{ textAlign: "center", margin: "20px" }}>
                    <Alert
                      message="No hay resultados"
                      description="No se encontraron registros de historial que coincidan con tu búsqueda."
                      type="info"
                      showIcon
                    />
                  </div>
                )}

                {/* Modal para visualizar cambios */}
                <Modal
                  title="Visualización de Cambios"
                  open={isModalVisible}
                  onCancel={cerrarModal}
                  footer={null}
                  width={600}
                >
                  {renderCambios()}
                </Modal>
              </div>
            </div>

            <Drawer
              onClose={() => setShowdetalleVisita(false)}
              title={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    position: "relative",
                  }}
                >
                  <h6
                    style={{ margin: 0, fontWeight: "bold", paddingRight: 50 }}
                  >
                    Detalle de la visita
                  </h6>

                  <div>
                    <Button
                      icon={<CloseOutlined />}
                      onClick={() => {
                        setShowdetalleVisita(false);
                      }}
                      style={{
                        position: "absolute",
                        right: 0,
                        top: "50%",
                        transform: "translateY(-50%)",
                        border: "none",
                        boxShadow: "none",
                      }}
                    />
                  </div>
                </div>
              }
              placement="right"
              open={showDetalleVisita}
              width={"100%"}
            >
              {itemSeleccionado && (
                <Renderizar
                  data={itemSeleccionado}
                  tipo_visita={itemSeleccionado.id_tipo_visita}
                  actionVolver={() => setShowdetalleVisita(false)} // Así está bien
                />
              )}
            </Drawer>
          </div>
        </>
      )}
    </>
  );
};

export default TablaHistorialVisitas;
